import { startWebGame } from './app/entrypoints/web.js';

startWebGame();
